/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceRuleConfig } from './InsuranceRuleConfig';
import {
    InsuranceRuleConfigFromJSON,
    InsuranceRuleConfigFromJSONTyped,
    InsuranceRuleConfigToJSON,
    InsuranceRuleConfigToJSONTyped,
} from './InsuranceRuleConfig';

/**
 * 
 * @export
 * @interface GetInsuranceRules200Response
 */
export interface GetInsuranceRules200Response {
    /**
     * 
     */
    data?: Array<InsuranceRuleConfig>;
}

/**
 * Check if a given object implements the GetInsuranceRules200Response interface.
 */
export function instanceOfGetInsuranceRules200Response(value: object): value is GetInsuranceRules200Response {
    return true;
}

export function GetInsuranceRules200ResponseFromJSON(json: any): GetInsuranceRules200Response {
    return GetInsuranceRules200ResponseFromJSONTyped(json, false);
}

export function GetInsuranceRules200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInsuranceRules200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(InsuranceRuleConfigFromJSON)),
    };
}

export function GetInsuranceRules200ResponseToJSON(json: any): GetInsuranceRules200Response {
    return GetInsuranceRules200ResponseToJSONTyped(json, false);
}

export function GetInsuranceRules200ResponseToJSONTyped(value?: GetInsuranceRules200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(InsuranceRuleConfigToJSON)),
    };
}

